.wrapper {
  position: relative;
  display: inline-flex;
}

.chevron {
  font-size: var(--text-xs);
  color: var(--text-muted);
}

/* Right-aligned: the trigger is the last thing on a row of actions, so a menu
   growing leftwards stays inside the card it belongs to. */
.menu {
  position: absolute;
  top: calc(100% + var(--space-1));
  right: 0;
  z-index: var(--z-overlay);
  display: flex;
  flex-direction: column;
  min-width: var(--measure-stat);
  padding: var(--space-1);
  background: var(--surface-overlay);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-md);
}

.item {
  min-height: var(--touch-target);
  padding: 0 var(--space-3);
  background: none;
  border: none;
  border-radius: var(--radius-sm);
  color: var(--text-primary);
  font-size: var(--text-sm);
  white-space: nowrap;
  text-align: left;
  cursor: pointer;
}

.item:hover,
.item:focus-visible {
  background: var(--surface-sunken);
}

.separated {
  margin-top: var(--space-1);
  padding-top: var(--space-1);
  border-top: 1px solid var(--border);
  border-radius: 0 0 var(--radius-sm) var(--radius-sm);
}

.danger {
  color: var(--intent-danger);
}
